// extracted by mini-css-extract-plugin
export default {"text":"CommonTable_text__LOhjl","headerTable":"CommonTable_headerTable__EH-iL","cellTable":"CommonTable_cellTable__54Fa7"};